import {MarkerType} from "react-flow-renderer";
import TaskNode from "src/pages/reactflow/TaskNode";

export const nodeTypes ={
    taskNode: TaskNode
}

export const getId = () => `${ new Date().valueOf().toString()+ new Date().getMilliseconds().toString()}`;

export const defaultEdgeOptions = {
    type: "step",
    style: { strokeWidth: 2, stroke: "#000" },
    markerEnd: MarkerType.ArrowClosed
};

export const nodes1 = [
    {
        id: "1",
        name: "Start",
        type: "input",
        data: {
            label: "Start",
        },
        position: { x: 150, y: 500 },
    },
    {
        id: "2",
        name: "End",
        type: "output",
        data: {
            label: "End",
        },
        position: { x: 150, y: 800 },
    },
];

export const edges1= [];